import { p } from '@/utils/content-blocks';

/** 旧版本归档表（下载按钮链到最新下载页） */
export const OLD_VERSION_ROWS = [
	{
		version: '18.80',
		size: '82 MB',
		android: '4.4+',
		releaseDate: 'May 2026',
		note: 'Current (recommended)',
		isCurrent: true,
	},
	{
		version: '17.50',
		size: '75 MB',
		android: '4.4+',
		releaseDate: 'Dec 2025',
		note: 'Stable archive',
		isCurrent: false,
	},
	{
		version: '17.30',
		size: '73 MB',
		android: '4.4+',
		releaseDate: 'Oct 2025',
		note: 'Stable archive',
		isCurrent: false,
	},
	{
		version: '17.00',
		size: '72 MB',
		android: '4.4+',
		releaseDate: 'Aug 2025',
		note: 'Legacy devices',
		isCurrent: false,
	},
	{
		version: '16.80',
		size: '70 MB',
		android: '4.4+',
		releaseDate: 'Jun 2025',
		note: 'Legacy only',
		isCurrent: false,
	},
];

/** 旧版 vs 新版对比 */
export const OLD_VS_NEW_ROWS = [
	{ aspect: 'Login reliability', oldVer: 'May fail on new servers', newVer: 'Best with v18.80' },
	{ aspect: 'Anti-ban patches', oldVer: 'Outdated signatures', newVer: 'Developer updates often' },
	{ aspect: 'Android 13+ storage', oldVer: 'Broken media on some builds', newVer: 'Improved scoped storage' },
	{ aspect: 'Feature set', oldVer: 'Fewer privacy toggles', newVer: 'Full current feature list' },
	{ aspect: 'File size', oldVer: 'Smaller (~70–75 MB)', newVer: 'Larger (~82 MB)' },
	{ aspect: 'Ban risk', oldVer: 'Higher if forced online', newVer: 'Lower when updated promptly' },
];

export const OLD_VERSION_SECTIONS = [
	{
		id: 'why-old',
		h2: 'Why Use Old Versions GB WhatsApp',
		blocks: [
			p([
				{
					text: 'Some users keep an older GB WhatsApp APK when a new build misbehaves on their phone, when RAM is tight, or when they need time to test an update on a secondary number. Old packages can feel faster on low-end chipsets because they ship less code—but they trade away security patches and server compatibility.',
				},
			]),
			p([
				{
					text: 'We recommend running the current release for everyday use. Treat archived versions as rollback options, not your primary install. Always verify file size and version label before sideloading any mirror.',
				},
			]),
		],
	},
	{
		id: 'version-list',
		h2: 'Available GB WhatsApp Old Versions List',
		layout: 'version-table',
		blocks: [
			p([
				{
					text: 'The table lists stable archives alongside the current 18.80 build. Download buttons point to our main ',
				},
				{ link: { to: '/download/', text: 'Download GB WhatsApp APK' } },
				{
					text: ' hub until per-version mirrors are hosted. Never install unsigned files from random Telegram channels.',
				},
			]),
		],
	},
	{
		id: 'download-old',
		h2: 'Download Old GB WhatsApp APK Files',
		blocks: [
			p([
				{
					text: 'To roll back, uninstall only after a local or Google Drive backup. Install the older APK over the current app only when package names and signatures match; otherwise Android blocks the overlay. If overlay fails, uninstall, install the old APK, then restore chats during setup.',
				},
			]),
			p([
				{
					text: 'For most users the safer path is to stay on version 18.80 and fix crashes with cache clears or permissions. Use 17.x only when support forums confirm that build still logs in in your region.',
				},
			]),
		],
	},
	{
		id: 'old-vs-new',
		h2: 'Old vs New Version Comparison',
		layout: 'old-vs-new-table',
		blocks: [
			p([
				{
					text: 'Newer mods track WhatsApp protocol changes. Old APKs may open but fail verification, hide outdated anti-ban strings, or break media pickers on Android 14. Compare below before you downgrade.',
				},
			]),
		],
	},
	{
		id: 'stability',
		h2: 'Stability Differences',
		blocks: [
			p([
				{
					text: 'Older builds sometimes feel snappier because they cache less and run fewer background hooks. That stability is deceptive if servers reject the client—you will spend more time re-verifying and restoring backups than you saved.',
				},
			]),
			p([
				{
					text: 'Long-term stability comes from matching the developer’s latest release, keeping 1 GB free storage, and avoiding aggressive privacy settings that trigger spam detection. See the update guide when you are ready to move forward again.',
				},
			]),
		],
	},
	{
		id: 'which-version',
		h2: 'Which GB WhatsApp Version to Choose',
		blocks: [
			p([
				{
					text: 'Choose 18.80 for daily messaging, new Android versions, and the best chance of passing verification. Choose 17.50 only if 18.x crashes on your device and forum reports show 17.50 still connects in your country. Choose 17.30 or older only for spare test phones—not your main work number.',
				},
			]),
			p([
				{ link: { to: '/download/', text: 'Download the latest GB WhatsApp APK' } },
				{ text: ' first; keep an old APK file offline only as emergency rollback.' },
			]),
		],
	},
	{
		id: 'risks',
		h2: 'Risks of GB WhatsApp Old Versions',
		blocks: [
			p([
				{
					text: 'Outdated mods increase ban risk because server-side checks detect old signatures. Malware authors also target people searching for “old GB WhatsApp” with fake APKs. Stick to gbwaps.com file notes and scan downloads when possible.',
				},
			]),
			p([
				{
					text: 'You may lose access to new privacy tools, break backup restore between mismatched versions, or expose chats if the old build lacks recent encryption fixes from the mod developer. When in doubt, update instead of downgrade.',
				},
			]),
		],
	},
];
